import {
  createUseReadContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
  createUseWriteContract,
} from 'wagmi/codegen';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// RSPContract
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const rspContractAbi = [
  { type: 'error', inputs: [], name: 'AlreadyRevealed' },
  { type: 'error', inputs: [], name: 'EarlyCallForCloseRoom' },
  { type: 'error', inputs: [], name: 'HiddedMoveAlreadySet' },
  { type: 'error', inputs: [], name: 'InvalidBetAmount' },
  {
    type: 'error',
    inputs: [
      { name: '', internalType: 'bytes32', type: 'bytes32' },
      { name: '', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'InvalidData',
  },
  { type: 'error', inputs: [], name: 'InvalidFeeValue' },
  { type: 'error', inputs: [], name: 'InvalidMove' },
  {
    type: 'error',
    inputs: [
      { name: 'round', internalType: 'uint16', type: 'uint16' },
      { name: 'roundCounter', internalType: 'uint16', type: 'uint16' },
    ],
    name: 'InvalidRound',
  },
  { type: 'error', inputs: [], name: 'InvalidTimeDuration' },
  { type: 'error', inputs: [], name: 'LowBetAmount' },
  { type: 'error', inputs: [], name: 'LowValue' },
  { type: 'error', inputs: [], name: 'NonexistentRoom' },
  { type: 'error', inputs: [], name: 'ReachedCloseRoomDeadline' },
  { type: 'error', inputs: [], name: 'SelfPlayProhibited' },
  { type: 'error', inputs: [], name: 'UnknownCaller' },
  { type: 'error', inputs: [], name: 'WithdrawFailed' },
  { type: 'error', inputs: [], name: 'WrongRoomStatus' },
  { type: 'error', inputs: [], name: 'ZeroAddress' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'receiver',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'CurrencySent',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'feePercentage',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'FeePercentageSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'feeReceiver',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'FeeReceiverSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [{ name: 'version', internalType: 'uint8', type: 'uint8', indexed: false }],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minBetAmount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'MinimalBetAmountSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'gameId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrant',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'MoveAdded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'potReceiver',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnerCloseUnusedRoom',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrant',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PlayerExit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'gameId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrant',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PlayerRevealedMove',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrantA',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'entrantB',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'PrivateRoomInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'referralAddr',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'referrerAddr',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'ReferrerConnected',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'feeValue',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
    ],
    name: 'ReferrerFeeSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'deadlineToCloseRoom',
        internalType: 'uint64',
        type: 'uint64',
        indexed: true,
      },
    ],
    name: 'RoomCloseDeadlineSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'receiver',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'receiverAddr',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      { name: 'pot', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'RoomClosed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrantA',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'entrantB',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'currency',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'betAmount',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'RoomCreated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'gameId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'winner',
        internalType: 'enum Rsp.RoundWinnerOutcomes',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'RoomGameHasDraw',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'gameId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'opponent',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'RoomGameStarted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrant',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'RoomJoined',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'potReceiver',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'UnusedRoomClosed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'roomId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'winsEntrantA',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'winsEntrantB',
        internalType: 'uint256',
        type: 'uint256',
        indexed: true,
      },
      {
        name: 'entrantA',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'entrantB',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'WinsCounterUpdated',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MAX_ROUND',
    outputs: [{ name: '', internalType: 'uint16', type: 'uint16' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'MIN_WINS',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'ONE_HUNDRED_PERCENT',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'activeRoomCounter',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomId', internalType: 'uint256', type: 'uint256' }],
    name: 'closeRoom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'closeRoomDeadline',
    outputs: [{ name: '', internalType: 'uint64', type: 'uint64' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomId', internalType: 'uint256', type: 'uint256' }],
    name: 'exitRoom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'fee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'feeReceiver',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomId', internalType: 'uint256', type: 'uint256' }],
    name: 'getAllRoomRounds',
    outputs: [
      {
        name: '',
        internalType: 'struct Rsp.GameRoomInfo[]',
        type: 'tuple[]',
        components: [
          { name: 'moveA', internalType: 'enum Rsp.Moves', type: 'uint8' },
          { name: 'moveB', internalType: 'enum Rsp.Moves', type: 'uint8' },
          { name: 'encrMoveA', internalType: 'bytes32', type: 'bytes32' },
          { name: 'encrMoveB', internalType: 'bytes32', type: 'bytes32' },
          {
            name: 'winner',
            internalType: 'enum Rsp.RoundWinnerOutcomes',
            type: 'uint8',
          },
          { name: 'stage', internalType: 'enum Rsp.GameStages', type: 'uint8' },
          {
            name: 'roundStage',
            internalType: 'enum Rsp.RoundStages',
            type: 'uint8',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomId', internalType: 'uint256', type: 'uint256' }],
    name: 'getCloserAddress',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomId', internalType: 'uint256', type: 'uint256' }],
    name: 'getCurrentRoomRound',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomId', internalType: 'uint256', type: 'uint256' }],
    name: 'getRoomCloser',
    outputs: [
      { name: '', internalType: 'enum Rsp.Closer', type: 'uint8' },
      { name: 'deadline', internalType: 'uint64', type: 'uint64' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'indexFrom', internalType: 'uint256', type: 'uint256' },
      { name: 'indexTo', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getRoomsInfo',
    outputs: [
      {
        name: '',
        internalType: 'struct Rsp.RoomInfo[]',
        type: 'tuple[]',
        components: [
          {
            name: 'data',
            internalType: 'struct Rsp.UniqRoomData',
            type: 'tuple',
            components: [
              { name: 'roomId', internalType: 'uint256', type: 'uint256' },
              { name: 'playerA', internalType: 'address', type: 'address' },
              { name: 'playerB', internalType: 'address', type: 'address' },
              { name: 'wins', internalType: 'uint8', type: 'uint8' },
              { name: 'token', internalType: 'address', type: 'address' },
              { name: 'bet', internalType: 'uint256', type: 'uint256' },
            ],
          },
          { name: 'pot', internalType: 'uint256', type: 'uint256' },
          { name: 'roundCounter', internalType: 'uint16', type: 'uint16' },
          {
            name: 'winsCounter',
            internalType: 'struct Rsp.PlayerWinCounter',
            type: 'tuple',
            components: [
              { name: 'winsPlayerA', internalType: 'uint8', type: 'uint8' },
              { name: 'winsPlayerB', internalType: 'uint8', type: 'uint8' },
            ],
          },
          { name: 'closer', internalType: 'enum Rsp.Closer', type: 'uint8' },
          { name: 'deadline', internalType: 'uint64', type: 'uint64' },
          {
            name: 'status',
            internalType: 'enum Rsp.RoomStatus',
            type: 'uint8',
          },
          {
            name: 'winnerStatus',
            internalType: 'enum Rsp.WinnerStatus',
            type: 'uint8',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'wins', internalType: 'uint8', type: 'uint8' },
      { name: 'currency', internalType: 'address', type: 'address' },
      { name: 'betAmount', internalType: 'uint256', type: 'uint256' },
      { name: 'playerB', internalType: 'address', type: 'address' },
      { name: 'referrer', internalType: 'address', type: 'address' },
    ],
    name: 'initRoom',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'closeRoomDeadline_', internalType: 'uint64', type: 'uint64' },
      { name: 'fee_', internalType: 'uint256', type: 'uint256' },
      { name: 'minBetAmount_', internalType: 'uint256', type: 'uint256' },
      { name: 'feeReceiver_', internalType: 'address', type: 'address' },
      { name: 'referrerFee_', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'roomId', internalType: 'uint256', type: 'uint256' },
      { name: 'referrer', internalType: 'address', type: 'address' },
    ],
    name: 'joinRoom',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'minBetAmount',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'roomIds', internalType: 'uint256[]', type: 'uint256[]' }],
    name: 'ownerCloseRooms',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'roomId', internalType: 'uint256', type: 'uint256' },
      { name: 'round', internalType: 'uint16', type: 'uint16' },
      { name: 'hiddenMove', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'playRoomGame',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'referrerFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'referrers',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'roomId', internalType: 'uint256', type: 'uint256' },
      { name: 'round', internalType: 'uint16', type: 'uint16' },
      { name: 'move', internalType: 'enum Rsp.Moves', type: 'uint8' },
      { name: 'salt', internalType: 'string', type: 'string' },
    ],
    name: 'reveal',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'roomIdCounter',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    name: 'rooms',
    outputs: [
      {
        name: 'data',
        internalType: 'struct Rsp.UniqRoomData',
        type: 'tuple',
        components: [
          { name: 'roomId', internalType: 'uint256', type: 'uint256' },
          { name: 'playerA', internalType: 'address', type: 'address' },
          { name: 'playerB', internalType: 'address', type: 'address' },
          { name: 'wins', internalType: 'uint8', type: 'uint8' },
          { name: 'token', internalType: 'address', type: 'address' },
          { name: 'bet', internalType: 'uint256', type: 'uint256' },
        ],
      },
      { name: 'pot', internalType: 'uint256', type: 'uint256' },
      { name: 'roundCounter', internalType: 'uint16', type: 'uint16' },
      {
        name: 'winsCounter',
        internalType: 'struct Rsp.PlayerWinCounter',
        type: 'tuple',
        components: [
          { name: 'winsPlayerA', internalType: 'uint8', type: 'uint8' },
          { name: 'winsPlayerB', internalType: 'uint8', type: 'uint8' },
        ],
      },
      { name: 'closer', internalType: 'enum Rsp.Closer', type: 'uint8' },
      { name: 'deadline', internalType: 'uint64', type: 'uint64' },
      { name: 'status', internalType: 'enum Rsp.RoomStatus', type: 'uint8' },
      {
        name: 'winnerStatus',
        internalType: 'enum Rsp.WinnerStatus',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '', internalType: 'uint256', type: 'uint256' },
      { name: '', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'rounds',
    outputs: [
      { name: 'moveA', internalType: 'enum Rsp.Moves', type: 'uint8' },
      { name: 'moveB', internalType: 'enum Rsp.Moves', type: 'uint8' },
      { name: 'encrMoveA', internalType: 'bytes32', type: 'bytes32' },
      { name: 'encrMoveB', internalType: 'bytes32', type: 'bytes32' },
      {
        name: 'winner',
        internalType: 'enum Rsp.RoundWinnerOutcomes',
        type: 'uint8',
      },
      { name: 'stage', internalType: 'enum Rsp.GameStages', type: 'uint8' },
      {
        name: 'roundStage',
        internalType: 'enum Rsp.RoundStages',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'fee_', internalType: 'uint256', type: 'uint256' }],
    name: 'setFeePercentage',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'feeReceiver_', internalType: 'address', type: 'address' }],
    name: 'setFeeReceiver',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'minBetAmount_', internalType: 'uint256', type: 'uint256' }],
    name: 'setMinimalBetAmount',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'referrerFee_', internalType: 'uint256', type: 'uint256' }],
    name: 'setReferrerFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'closeRoomDeadline_', internalType: 'uint64', type: 'uint64' }],
    name: 'setRoomCloseDeadline',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const;

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const rspContractAddress = {
  1: '0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF',
  137: '0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF',
  8453: '0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF',
  42161: '0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF',
} as const;

/**
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const rspContractConfig = {
  address: rspContractAddress,
  abi: rspContractAbi,
} as const;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContract = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"MAX_ROUND"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractMaxRound = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'MAX_ROUND',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"MIN_WINS"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractMinWins = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'MIN_WINS',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"ONE_HUNDRED_PERCENT"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractOneHundredPercent = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'ONE_HUNDRED_PERCENT',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"activeRoomCounter"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractActiveRoomCounter = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'activeRoomCounter',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"closeRoomDeadline"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractCloseRoomDeadline = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'closeRoomDeadline',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"fee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractFee = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'fee',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"feeReceiver"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractFeeReceiver = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'feeReceiver',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"getAllRoomRounds"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractGetAllRoomRounds = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'getAllRoomRounds',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"getCloserAddress"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractGetCloserAddress = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'getCloserAddress',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"getCurrentRoomRound"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractGetCurrentRoomRound = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'getCurrentRoomRound',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"getRoomCloser"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractGetRoomCloser = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'getRoomCloser',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"getRoomsInfo"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractGetRoomsInfo = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'getRoomsInfo',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"minBetAmount"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractMinBetAmount = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'minBetAmount',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"owner"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractOwner = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'owner',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"referrerFee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractReferrerFee = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'referrerFee',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"referrers"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractReferrers = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'referrers',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"roomIdCounter"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractRoomIdCounter = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'roomIdCounter',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"rooms"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractRooms = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'rooms',
});

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"rounds"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useReadRspContractRounds = /*#__PURE__*/ createUseReadContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'rounds',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContract = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"closeRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractCloseRoom = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'closeRoom',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"exitRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractExitRoom = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'exitRoom',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"initRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractInitRoom = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'initRoom',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractInitialize = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'initialize',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"joinRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractJoinRoom = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'joinRoom',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"ownerCloseRooms"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractOwnerCloseRooms = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'ownerCloseRooms',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"playRoomGame"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractPlayRoomGame = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'playRoomGame',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractRenounceOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'renounceOwnership',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"reveal"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractReveal = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'reveal',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setFeePercentage"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractSetFeePercentage = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setFeePercentage',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setFeeReceiver"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractSetFeeReceiver = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setFeeReceiver',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setMinimalBetAmount"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractSetMinimalBetAmount = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setMinimalBetAmount',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setReferrerFee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractSetReferrerFee = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setReferrerFee',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setRoomCloseDeadline"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractSetRoomCloseDeadline = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setRoomCloseDeadline',
});

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWriteRspContractTransferOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'transferOwnership',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContract = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"closeRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractCloseRoom = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'closeRoom',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"exitRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractExitRoom = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'exitRoom',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"initRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractInitRoom = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'initRoom',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"initialize"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractInitialize = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'initialize',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"joinRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractJoinRoom = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'joinRoom',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"ownerCloseRooms"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractOwnerCloseRooms = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'ownerCloseRooms',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"playRoomGame"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractPlayRoomGame = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'playRoomGame',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"renounceOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractRenounceOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'renounceOwnership',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"reveal"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractReveal = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'reveal',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setFeePercentage"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractSetFeePercentage = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setFeePercentage',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setFeeReceiver"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractSetFeeReceiver = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setFeeReceiver',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setMinimalBetAmount"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractSetMinimalBetAmount = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setMinimalBetAmount',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setReferrerFee"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractSetReferrerFee = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setReferrerFee',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"setRoomCloseDeadline"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractSetRoomCloseDeadline = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'setRoomCloseDeadline',
});

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link rspContractAbi}__ and `functionName` set to `"transferOwnership"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useSimulateRspContractTransferOwnership = /*#__PURE__*/ createUseSimulateContract({
  abi: rspContractAbi,
  address: rspContractAddress,
  functionName: 'transferOwnership',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"CurrencySent"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractCurrencySentEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'CurrencySent',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"FeePercentageSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractFeePercentageSetEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'FeePercentageSet',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"FeeReceiverSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractFeeReceiverSetEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'FeeReceiverSet',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"Initialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractInitializedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'Initialized',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"MinimalBetAmountSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractMinimalBetAmountSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'MinimalBetAmountSet',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"MoveAdded"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractMoveAddedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'MoveAdded',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"OwnerCloseUnusedRoom"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractOwnerCloseUnusedRoomEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'OwnerCloseUnusedRoom',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"OwnershipTransferred"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'OwnershipTransferred',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"PlayerExit"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractPlayerExitEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'PlayerExit',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"PlayerRevealedMove"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractPlayerRevealedMoveEvent = /*#__PURE__*/ createUseWatchContractEvent(
  {
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'PlayerRevealedMove',
  },
);

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"PrivateRoomInitialized"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractPrivateRoomInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'PrivateRoomInitialized',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"ReferrerConnected"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractReferrerConnectedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'ReferrerConnected',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"ReferrerFeeSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractReferrerFeeSetEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'ReferrerFeeSet',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"RoomCloseDeadlineSet"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractRoomCloseDeadlineSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'RoomCloseDeadlineSet',
  });

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"RoomClosed"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractRoomClosedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'RoomClosed',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"RoomCreated"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractRoomCreatedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'RoomCreated',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"RoomGameHasDraw"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractRoomGameHasDrawEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'RoomGameHasDraw',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"RoomGameStarted"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractRoomGameStartedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'RoomGameStarted',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"RoomJoined"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractRoomJoinedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'RoomJoined',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"UnusedRoomClosed"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractUnusedRoomClosedEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: rspContractAbi,
  address: rspContractAddress,
  eventName: 'UnusedRoomClosed',
});

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link rspContractAbi}__ and `eventName` set to `"WinsCounterUpdated"`
 *
 * - [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Polygon Polygon Scan__](https://polygonscan.com/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Base Basescan__](https://basescan.org/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 * - [__View Contract on Arbitrum One Arbiscan__](https://arbiscan.io/address/0xAe447C1F7d2d504AD6dCe2dd28f35aA0F1bfF9CF)
 */
export const useWatchRspContractWinsCounterUpdatedEvent = /*#__PURE__*/ createUseWatchContractEvent(
  {
    abi: rspContractAbi,
    address: rspContractAddress,
    eventName: 'WinsCounterUpdated',
  },
);
